import { render, staticRenderFns } from "./TrafficFineApprovalStatusBadge.vue?vue&type=template&id=d4e5a1ca&"
import script from "./TrafficFineApprovalStatusBadge.vue?vue&type=script&lang=js&"
export * from "./TrafficFineApprovalStatusBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports